import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { analyticsApi } from 'src/services/analyticsApi'
import { OperatorAnalyticsResponse } from 'src/services/__generated__/api'

interface UseGetOperatorAnalyticsParams {
  fromDate?: string
  pageId: string
  // Time-of-day window for response times: all hours, 09:00–19:00, 19:00–09:00.
  period: 'overall' | 'morning' | 'evening'
  // Single platform id; 'all' (or omitted) means every platform.
  platform?: string
  toDate?: string
}

export const useGetOperatorAnalyticsQuery = (
  params: UseGetOperatorAnalyticsParams
) => {
  // Morning/evening windows and the top day are evaluated in the viewer's
  // timezone, like the Response Time section.
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
  const platforms =
    params.platform && params.platform !== 'all' ? params.platform : undefined

  return useQuery<OperatorAnalyticsResponse>({
    enabled: !!params.pageId,
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const { data } = await analyticsApi().get<OperatorAnalyticsResponse>(
        '/v1_private/inbox-analysis/operator-analytics',
        {
          params: {
            fromDate: params.fromDate,
            pageId: params.pageId,
            period: params.period,
            platforms,
            toDate: params.toDate,
            tz: timezone,
          },
        }
      )
      return data
    },
    queryKey: [
      QueryKey.GET_OPERATOR_ANALYTICS,
      params.pageId,
      params.fromDate,
      params.toDate,
      platforms,
      params.period,
      timezone,
    ],
  })
}
